__turbopack_context__.v({
  "active": "STs9Pa_active",
  "bar": "STs9Pa_bar",
  "dot": "STs9Pa_dot",
  "imageInSwiper": "STs9Pa_imageInSwiper",
  "pagination": "STs9Pa_pagination",
  "partialImageSlider": "STs9Pa_partialImageSlider",
  "slide": "STs9Pa_slide",
  "slideActive": "STs9Pa_slideActive",
  "toLeft": "STs9Pa_toLeft",
  "toRight": "STs9Pa_toRight",
});
